const validatorToPredicate =
  (validatorFn, emptyCase) =>
  (value, ...rest) =>
    value === '' ? emptyCase : validatorFn(value, ...rest);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var dayjs_min = {exports: {}};

dayjs_min.exports;

(function (module, exports) {
	!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return "["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w})); 
} (dayjs_min, dayjs_min.exports));

var dayjs_minExports = dayjs_min.exports;
var dayjs = /*@__PURE__*/getDefaultExportFromCjs(dayjs_minExports);

var customParseFormat$1 = {exports: {}};

customParseFormat$1.exports;

(function (module, exports) {
	!function(e,t){module.exports=t();}(commonjsGlobal,(function(){var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},t=/(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d\d/,r=/\d\d?/,i=/\d*[^-_:/,()\s\d]+/,o={},s=function(e){return (e=+e)+(e>68?1900:2e3)};var a=function(e){return function(t){this[e]=+t;}},f=[/[+-]\d\d:?(\d\d)?|Z/,function(e){(this.zone||(this.zone={})).offset=function(e){if(!e)return 0;if("Z"===e)return 0;var t=e.match(/([+-]|\d\d)/g),n=60*t[1]+(+t[2]||0);return 0===n?0:"+"===t[0]?-n:n}(e);}],h=function(e){var t=o[e];return t&&(t.indexOf?t:t.s.concat(t.f))},u=function(e,t){var n,r=o.meridiem;if(r){for(var i=1;i<=24;i+=1)if(e.indexOf(r(i,0,t))>-1){n=i>12;break}}else n=e===(t?"pm":"PM");return n},d={A:[i,function(e){this.afternoon=u(e,!1);}],a:[i,function(e){this.afternoon=u(e,!0);}],S:[/\d/,function(e){this.milliseconds=100*+e;}],SS:[n,function(e){this.milliseconds=10*+e;}],SSS:[/\d{3}/,function(e){this.milliseconds=+e;}],s:[r,a("seconds")],ss:[r,a("seconds")],m:[r,a("minutes")],mm:[r,a("minutes")],H:[r,a("hours")],h:[r,a("hours")],HH:[r,a("hours")],hh:[r,a("hours")],D:[r,a("day")],DD:[n,a("day")],Do:[i,function(e){var t=o.ordinal,n=e.match(/\d+/);if(this.day=n[0],t)for(var r=1;r<=31;r+=1)t(r).replace(/\[|\]/g,"")===e&&(this.day=r);}],M:[r,a("month")],MM:[n,a("month")],MMM:[i,function(e){var t=h("months"),n=(h("monthsShort")||t.map((function(e){return e.slice(0,3)}))).indexOf(e)+1;if(n<1)throw new Error;this.month=n%12||n;}],MMMM:[i,function(e){var t=h("months").indexOf(e)+1;if(t<1)throw new Error;this.month=t%12||t;}],Y:[/[+-]?\d+/,a("year")],YY:[n,function(e){this.year=s(e);}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};function c(n){var r,i;r=n,i=o&&o.formats;for(var s=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var o=r&&r.toUpperCase();return n||i[r]||e[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,n){return t||n.slice(1)}))}))).match(t),a=s.length,f=0;f<a;f+=1){var h=s[f],u=d[h],c=u&&u[0],l=u&&u[1];s[f]=l?{regex:c,parser:l}:h.replace(/^\[|\]$/g,"");}return function(e){for(var t={},n=0,r=0;n<a;n+=1){var i=s[n];if("string"==typeof i)r+=i.length;else {var o=i.regex,f=i.parser,h=e.slice(r),u=o.exec(h)[0];f.call(t,u),e=e.replace(u,"");}}return function(e){var t=e.afternoon;if(void 0!==t){var n=e.hours;t?n<12&&(e.hours+=12):12===n&&(e.hours=0),delete e.afternoon;}}(t),t}}return function(e,t,n){n.p.customParseFormat=!0,e&&e.parseTwoDigitYear&&(s=e.parseTwoDigitYear);var r=t.prototype,i=r.parse;r.parse=function(e){var t=e.date,r=e.utc,s=e.args;this.$u=r;var a=s[1];if("string"==typeof a){var f=!0===s[2],h=!0===s[3],u=f||h,d=s[2];h&&(d=s[2]),o=this.$locale(),!f&&d&&(o=n.Ls[d]),this.$d=function(e,t,n){try{if(["x","X"].indexOf(t)>-1)return new Date(("X"===t?1e3:1)*e);var r=c(t)(e),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,h=r.seconds,u=r.milliseconds,d=r.zone,l=new Date,m=s||(i||o?1:l.getDate()),M=i||l.getFullYear(),Y=0;i&&!o||(Y=o>0?o-1:l.getMonth());var p=a||0,v=f||0,D=h||0,g=u||0;return d?new Date(Date.UTC(M,Y,m,p,v,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(M,Y,m,p,v,D,g)):new Date(M,Y,m,p,v,D,g)}catch(e){return new Date("")}}(t,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),u&&t!=this.format(a)&&(this.$d=new Date("")),o={};}else if(a instanceof Array)for(var l=a.length,m=1;m<=l;m+=1){s[1]=a[m-1];var M=n.apply(this,s);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===l&&(this.$d=new Date(""));}else i.call(this,e);};}})); 
} (customParseFormat$1, customParseFormat$1.exports));

var customParseFormatExports = customParseFormat$1.exports;
var customParseFormat = /*@__PURE__*/getDefaultExportFromCjs(customParseFormatExports);

var isSameOrBefore$1 = {exports: {}};

isSameOrBefore$1.exports;

(function (module, exports) {
	!function(e,i){module.exports=i();}(commonjsGlobal,(function(){return function(e,i){i.prototype.isSameOrBefore=function(e,i){return this.isSame(e,i)||this.isBefore(e,i)};}})); 
} (isSameOrBefore$1, isSameOrBefore$1.exports));

var isSameOrBeforeExports = isSameOrBefore$1.exports;
var isSameOrBefore = /*@__PURE__*/getDefaultExportFromCjs(isSameOrBeforeExports);

var isSameOrAfter$1 = {exports: {}};

isSameOrAfter$1.exports;

(function (module, exports) {
	!function(e,t){module.exports=t();}(commonjsGlobal,(function(){return function(e,t){t.prototype.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)};}})); 
} (isSameOrAfter$1, isSameOrAfter$1.exports));

var isSameOrAfterExports = isSameOrAfter$1.exports;
var isSameOrAfter = /*@__PURE__*/getDefaultExportFromCjs(isSameOrAfterExports);

/* eslint-disable no-unused-vars */

const createValidator = (type, error) => {
  let validator = (...args) => ({ type, args, error });
  validator.error = error;
  return validator;
};

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

let validatorFns = {};

const INCLUDED_IN = 'validator/INCLUDED_IN';
const INCLUDED_IN_ERROR = 'error/INCLUDED_IN';
const includedIn = createValidator(INCLUDED_IN, INCLUDED_IN_ERROR);
validatorFns[INCLUDED_IN] = (value, args, form) =>
  Array.isArray(args[0]) ? args[0].includes(value) : args[0] === value;

const REQUIRED = 'validator/REQUIRED';
const REQUIRED_ERROR = 'error/REQUIRED';
const required = createValidator(REQUIRED, REQUIRED_ERROR);
validatorFns[REQUIRED] = (value, args, form) => value !== '';

const ONLY_INTEGERS = 'validator/ONLY_INTEGERS';
const ONLY_INTEGERS_ERROR = 'error/ONLY_INTEGERS';
const onlyIntegers = createValidator(ONLY_INTEGERS, ONLY_INTEGERS_ERROR);
validatorFns[ONLY_INTEGERS] = (value, args, form) => /^(-?\d+)?$/.test(value);

const ONLY_NATURALS = 'validator/ONLY_NATURALS';
const ONLY_NATURALS_ERROR = 'error/ONLY_NATURALS';
const onlyNaturals = createValidator(ONLY_NATURALS, ONLY_NATURALS_ERROR);
validatorFns[ONLY_NATURALS] = (value, args, form) => /^(\d+)?$/.test(value);

/* 
07/22: experimental expiration date constraint
should allow entry of expiration date using "/" character
to accommodate browser autofill

not tested as validation function
to validate exp date instead use combo of:
required(), hasLength(), isValidMonth(), dateAfterToday()
*/
const ONLY_EXPIRATION_DATE = 'validator/ONLY_EXPIRATION_DATE';
const ONLY_EXPIRATION_DATE_ERROR = 'error/ONLY_EXPIRATION_DATE';
const onlyExpirationDate = createValidator(
  ONLY_EXPIRATION_DATE,
  ONLY_EXPIRATION_DATE_ERROR
);
validatorFns[ONLY_EXPIRATION_DATE] = (value, args, form) =>
  /^(\d?\d?\/?\d?\d?)?$/.test(value);

/*
11/24 - Users have been adding full CC numbers to the name field
This validator will check if the value has more than 6 numeric characters
We have to allow for some numeric characters to account for business
names that include numbers like "3M Company" or "Smith Street Trust 40389"

1/25 - This has been superseded by the includesPotentialCardNumber validator
*/
const NO_MORE_THAN_SIX_NUMBERS = 'validator/NO_MORE_THAN_SIX_NUMBERS';
const NO_MORE_THAN_SIX_NUMBERS_ERROR = 'error/NO_MORE_THAN_SIX_NUMBERS';
createValidator(
  NO_MORE_THAN_SIX_NUMBERS,
  NO_MORE_THAN_SIX_NUMBERS_ERROR
);
validatorFns[NO_MORE_THAN_SIX_NUMBERS] = (value) => {
  if (value === '') {
    return true;
  }
  return !/(\d.*){7,}/.test(value);
};

/*
 * 1/25 - Prevent users from entering full credit card numbers in the "name" field.
 *
 * This validator is designed to reduce the accidental inclusion of credit card numbers
 * in fields where they don't belong (e.g., the name field). It identifies a potential
 * credit card number based on the following criteria:
 *
 * - It consists of 8 to 20 digits.
 * - Digits may be separated by optional spaces or hyphens.
 * - It must pass the Luhn algorithm check.
 *
 * Note:
 *   A string passing the Luhn algorithm is necessary but not sufficient to conclusively
 *   determine that the string is a valid credit card number.
 *
 * For more details on the Luhn algorithm, refer to:
 * https://stripe.com/en-ca/resources/more/how-to-use-the-luhn-algorithm-a-guide-in-applications-for-businesses#luhn-algorithm-formula
 */

function luhnValid(string) {
  if (!string) {
    return false;
  }

  // Extract all digit characters from the string.
  const digits = string.match(/\d/g);
  if (!digits) {
    return false;
  }

  let totalSum = 0;
  let shouldDouble = false;

  // Process digits from right to left
  for (let i = digits.length - 1; i >= 0; i--) {
    // Convert the current character to a number.
    let digit = parseInt(digits[i], 10);

    // Double the digit and adjust if it exceeds 9.
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        // If the result of any doubling operation is greater than nine,
        // then add the digits of the result together to obtain a single-digit number.
        // This is equivalent to adding the digits together (e.g. 16: 1 + 6 = 7 = 16 - 9).
        digit -= 9;
      }
    }

    // Add the processed digit to the total sum.
    totalSum += digit;
    // After doubling the value of the second-to-last digit, continue doing the same for every other digit.
    shouldDouble = !shouldDouble;
  }

  // The number is valid if totalSum is divisible by 10.
  return totalSum % 10 === 0;
}

const INCLUDES_POTENTIAL_CARD_NUMBER =
  'validator/INCLUDES_POTENTIAL_CARD_NUMBER';
const INCLUDES_POTENTIAL_CARD_NUMBER_ERROR =
  'error/INCLUDES_POTENTIAL_CARD_NUMBER';
const includesPotentialCardNumber = createValidator(
  INCLUDES_POTENTIAL_CARD_NUMBER,
  INCLUDES_POTENTIAL_CARD_NUMBER_ERROR
);
validatorFns[INCLUDES_POTENTIAL_CARD_NUMBER] = (value) => {
  // This is the same regex currently used in Ghenghis
  // A potential credit card number is a sequence of 8 to 20 digits, with optional spaces or hyphens between them
  const regexString = '(?:\\d[ -]*){8,20}';
  const regex = new RegExp(regexString);
  return !(luhnValid(value) && regex.test(value));
};

const NUMBER_LESS_THAN = 'validator/NUMBER_LESS_THAN';
const NUMBER_LESS_THAN_ERROR = 'error/NUMBER_LESS_THAN';
const numberLessThan = createValidator(
  NUMBER_LESS_THAN,
  NUMBER_LESS_THAN_ERROR
);
validatorFns[NUMBER_LESS_THAN] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return Number(value) < args[0];
};

const NUMBER_LESS_THAN_OR_EQUAL_TO = 'validator/NUMBER_LESS_THAN_OR_EQUAL_TO';
const NUMBER_LESS_THAN_OR_EQUAL_TO_ERROR =
  'error/NUMBER_LESS_THAN_OR_EQUAL_TO';
const numberLessThanOrEqualTo = createValidator(
  NUMBER_LESS_THAN_OR_EQUAL_TO,
  NUMBER_LESS_THAN_OR_EQUAL_TO_ERROR
);
validatorFns[NUMBER_LESS_THAN_OR_EQUAL_TO] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return Number(value) <= args[0];
};

const NUMBER_GREATER_THAN = 'validator/NUMBER_GREATER_THAN';
const NUMBER_GREATER_THAN_ERROR = 'error/NUMBER_GREATER_THAN';
const numberGreaterThan = createValidator(
  NUMBER_GREATER_THAN,
  NUMBER_GREATER_THAN_ERROR
);
validatorFns[NUMBER_GREATER_THAN] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return Number(value) > args[0];
};

const NUMBER_GREATER_THAN_OR_EQUAL_TO =
  'validator/NUMBER_GREATER_THAN_OR_EQUAL_TO';
const NUMBER_GREATER_THAN_OR_EQUAL_TO_ERROR =
  'error/NUMBER_GREATER_THAN_OR_EQUAL_TO';
const numberGreaterThanOrEqualTo = createValidator(
  NUMBER_GREATER_THAN_OR_EQUAL_TO,
  NUMBER_GREATER_THAN_OR_EQUAL_TO_ERROR
);
validatorFns[NUMBER_GREATER_THAN_OR_EQUAL_TO] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return Number(value) >= args[0];
};

const MATCHES_FIELD = 'validator/MATCHES_FIELD';
const MATCHES_FIELD_ERROR = 'error/MATCHES_FIELD';
const matchesField = createValidator(MATCHES_FIELD, MATCHES_FIELD_ERROR);
validatorFns[MATCHES_FIELD] = (value, args, form) => {
  const dependentField = form[args[0]];
  if (dependentField === undefined) {
    throw new Error(
      `${args[0]} was passed to matchesField, but that field does not exist in the form`
    );
  }
  const dependentFieldValue = dependentField.rawValue;
  return value === dependentFieldValue;
};

const validateWhenErrorMessage = (type) =>
  `${type} was passed to validateWhen, but that validator type does not exist.
  Please check that you are only calling validator creator functions exported from
  redux-freeform in your form config and that you didn't forget to
  invoke the validator creator (you cannot pass the functions themselves to
  createFormState). Also make sure you aren't passing validateWhen() to validateWhen
  as the primary validator.`;

const VALIDATE_WHEN = 'validator/VALIDATE_WHEN';
const VALIDATE_WHEN_ERROR = 'error/VALIDATE_WHEN';
const validateWhen = (dependentValidator, primaryValidator, optionalFieldName) => ({
  type: VALIDATE_WHEN,
  args: [dependentValidator, primaryValidator, optionalFieldName],
  error: dependentValidator.error,
});
validateWhen.error = VALIDATE_WHEN_ERROR;
validatorFns[VALIDATE_WHEN] = (value, args, form) => {
  const [dependentValidator, primaryValidator, optionalFieldName] = args;
  const dependsOnOtherField = typeof optionalFieldName === 'string';

  if (
    primaryValidator.type === undefined ||
    typeof validatorFns[primaryValidator.type] !== 'function'
  ) {
    throw new Error(validateWhenErrorMessage(primaryValidator.type));
  }
  if (dependsOnOtherField && form[optionalFieldName] === undefined) {
    throw new Error(
      `${args[2]} was passed to matchesField, but that field does not exist in the form`
    );
  }

  const primaryPredicate = validatorToPredicate(
    validatorFns[primaryValidator.type],
    false
  );
  const primaryValue = dependsOnOtherField
    ? form[optionalFieldName].rawValue
    : value;
  const primaryPredicatePassed = primaryPredicate(
    primaryValue,
    primaryValidator.args,
    form
  );

  return primaryPredicatePassed
    ? validatorFns[dependentValidator.type](value, dependentValidator.args, form)
    : true;
};

const validateSumErrorMessage = (type) =>
  `${type} was passed to validateSum, but that validator type does not exist.
  Please check that you are only calling validator creator functions exported from
  redux-freeform in your form config and that you didn't forget to
  invoke the validator creator (you cannot pass the functions themselves to
  createFormState).`;
const VALIDATE_SUM = 'validator/VALIDATE_SUM';
const VALIDATE_SUM_ERROR = 'error/VALIDATE_SUM';
const validateSum = (validator, fieldNamesArray) => ({
  type: VALIDATE_SUM,
  args: [validator, fieldNamesArray],
  error: validator.error,
});
validateSum.error = VALIDATE_SUM_ERROR;
validatorFns[VALIDATE_SUM] = (value, args, form) => {
  const [validator, fieldNamesArray] = args;

  if (
    validator.type === undefined ||
    typeof validatorFns[validator.type] !== 'function'
  ) {
    throw new Error(validateSumErrorMessage(validator.type));
  }

  for (const fieldName of fieldNamesArray) {
    if (form[fieldName] === undefined) {
      throw new Error(
        `${fieldName} was passed to matchesField, but that field does not exist in the form`
      );
    }
  }

  const sum = fieldNamesArray.reduce(
    (acc, curr) => acc + Number(form[curr].rawValue),
    Number(value)
  );

  return validatorFns[validator.type](sum, validator.args, form);
};

const HAS_LENGTH = 'validator/HAS_LENGTH';
const HAS_LENGTH_ERROR = 'error/HAS_LENGTH';
const hasLength = createValidator(HAS_LENGTH, HAS_LENGTH_ERROR);
validatorFns[HAS_LENGTH] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  const min = args[0];
  const max = args[1];
  if (max == undefined || min == undefined) {
    throw new Error(
      'Max and min need to be defined for hasLength, both or one of them is undefined'
    );
  }
  if (max < min) {
    throw new Error('hasLength validator was passed a min greater than the max');
  }
  const valueLength = value.length;
  return max >= valueLength && valueLength >= min;
};

const DATE_BEFORE_TODAY = 'validator/DATE_BEFORE_TODAY';
const DATE_BEFORE_TODAY_ERROR = 'error/DATE_BEFORE_TODAY';
const dateBeforeToday = createValidator(
  DATE_BEFORE_TODAY,
  DATE_BEFORE_TODAY_ERROR
);
validatorFns[DATE_BEFORE_TODAY] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  const dateFormat = args[0];
  const unit = args[1];
  const inclusive = args[2] || false;

  if (dateFormat == undefined || unit == undefined) {
    throw new Error(
      'Date format and unit need to be defined for dateBeforeToday, one or both are undefined'
    );
  }
  const now = dayjs();
  const dateValue = dayjs(value, dateFormat);

  if (inclusive === true) {
    return dateValue.isSameOrBefore(now, unit);
  }
  return dateValue.isBefore(now, unit);
};

const DATE_AFTER_TODAY = 'validator/DATE_AFTER_TODAY';
const DATE_AFTER_TODAY_ERROR = 'error/DATE_AFTER_TODAY';
const dateAfterToday = createValidator(
  DATE_AFTER_TODAY,
  DATE_AFTER_TODAY_ERROR
);
validatorFns[DATE_AFTER_TODAY] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  const dateFormat = args[0];
  const unit = args[1];
  const inclusive = args[2] || false;

  if (dateFormat == undefined || unit == undefined) {
    throw new Error(
      'Date format and unit need to be defined for dateAfterToday, one or both are undefined'
    );
  }
  const now = dayjs();
  const dateValue = dayjs(value, dateFormat);

  if (inclusive === true) {
    return dateValue.isSameOrAfter(now, unit);
  }
  return dateValue.isAfter(now, unit);
};

const IS_VALID_MONTH = 'validator/IS_VALID_MONTH';
const IS_VALID_MONTH_ERROR = 'error/IS_VALID_MONTH';
const isValidMonth = createValidator(IS_VALID_MONTH, IS_VALID_MONTH_ERROR);
validatorFns[IS_VALID_MONTH] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  // Function takes one argument representing the character position
  // In a date string to identify where the month is
  // Eg "10/21/2021" - start position is 0
  // Or "18/03/1990" - start position is 3
  // Only works with two digit months (01, 02, 03, etc)
  const monthStartPosition = parseInt(args[0]);
  const monthEndPosition = monthStartPosition + 2;
  if (isNaN(monthStartPosition)) {
    throw new Error('Month start position has to be a valid integer string');
  }
  const month = parseInt(value.slice(monthStartPosition, monthEndPosition));
  if (isNaN(month)) {
    return false;
  }
  return month >= 1 && month <= 12;
};

const MATCHES_REGEX = 'validator/MATCHES_REGEX';
const MATCHES_REGEX_ERROR = 'error/MATCHES_REGEX';
const matchesRegex = createValidator(MATCHES_REGEX, MATCHES_REGEX_ERROR);
validatorFns[MATCHES_REGEX] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return new RegExp(args[0]).test(value); // new RexExp never throws an error, no matter the input
};

// based on http://www.brainjar.com/js/validation/
const IS_ROUTING_NUMBER = 'validator/IS_ROUTING_NUMBER';
const IS_ROUTING_NUMBER_ERROR = 'error/IS_ROUTING_NUMBER';
const isRoutingNumber = createValidator(
  IS_ROUTING_NUMBER,
  IS_ROUTING_NUMBER_ERROR
);
validatorFns[IS_ROUTING_NUMBER] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  if (value.length != 9) {
    return false;
  }
  const sum = value
    .split('')
    .map((ch) => parseInt(ch))
    .reduce((acc, cur, idx) => {
      switch (idx % 3) {
        case 0:
          return acc + 3 * cur;
        case 1:
          return acc + 7 * cur;
        case 2:
          return acc + 1 * cur;
      }
    }, 0);
  return sum != 0 && sum % 10 == 0;
};

const HAS_NUMBER = 'validator/HAS_NUMBER';
const HAS_NUMBER_ERROR = 'error/HAS_NUMBER';
const hasNumber = createValidator(HAS_NUMBER, HAS_NUMBER_ERROR);
validatorFns[HAS_NUMBER] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return new RegExp(/[0-9]/).test(value);
};

const HAS_LOWERCASE_LETTER = 'validator/HAS_LOWERCASE_LETTER';
const HAS_LOWERCASE_LETTER_ERROR = 'error/HAS_LOWERCASE_LETTER';
const hasLowercaseLetter = createValidator(
  HAS_LOWERCASE_LETTER,
  HAS_LOWERCASE_LETTER_ERROR
);
validatorFns[HAS_LOWERCASE_LETTER] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return new RegExp(/[a-z]/).test(value);
};

const HAS_UPPERCASE_LETTER = 'validator/HAS_UPPERCASE_LETTER';
const HAS_UPPERCASE_LETTER_ERROR = 'error/HAS_UPPERCASE_LETTER';
const hasUppercaseLetter = createValidator(
  HAS_UPPERCASE_LETTER,
  HAS_UPPERCASE_LETTER_ERROR
);
validatorFns[HAS_UPPERCASE_LETTER] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return new RegExp(/[A-Z]/).test(value);
};

const HAS_SPECIAL_CHARACTER = 'validator/HAS_SPECIAL_CHARACTER';
const HAS_SPECIAL_CHARACTER_ERROR = 'error/HAS_SPECIAL_CHARACTER';
const hasSpecialCharacter = createValidator(
  HAS_SPECIAL_CHARACTER,
  HAS_SPECIAL_CHARACTER_ERROR
);
validatorFns[HAS_SPECIAL_CHARACTER] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return new RegExp(/[!@#$%^&*.?]/).test(value);
};

const IS_PROBABLY_EMAIL = 'validator/IS_PROBABLY_EMAIL';
const IS_PROBABLY_EMAIL_ERROR = 'error/IS_PROBABLY_EMAIL';
const isProbablyEmail = createValidator(
  IS_PROBABLY_EMAIL,
  IS_PROBABLY_EMAIL_ERROR
);
validatorFns[IS_PROBABLY_EMAIL] = (value, args, form) => {
  if (value === '') {
    return true;
  }
  return new RegExp(/^\S+@\S+\.\S+$/).test(value);
};

const VALID_NAME = 'validator/VALID_NAME';
const VALID_NAME_ERROR = 'validator/VALID_NAME_ERROR';
const validName = createValidator(VALID_NAME, VALID_NAME_ERROR);
validatorFns[VALID_NAME] = (value, args, form) =>
  value === ''
    ? false
    : new RegExp(/[A-zÀ-ÿ\-,'\S]+(\s?[A-zÀ-ÿ\-,'\S])*/).test(value);

const runValidatorErrorMessage = (type) =>
  `${type} was passed to runValidator, but that validator type does not exist. 
  Please check that you are only calling validator creator functions exported from 
  redux-freeform in your form config and that you didn't forget to 
  invoke the validator creator (you cannot pass the functions themselves to 
  createFormState)`;

const runValidator = (validator, value, form) => {
  const validatorFn = validatorFns[validator.type];
  if (validatorFn === undefined) {
    throw new Error(runValidatorErrorMessage(validator.type));
  }
  return validatorFn(value, validator.args, form) ? null : validator.error;
};

const runFormValidators = (fieldName, form, validators) => {
  return validators
    .map((v) => runValidator(v, form[fieldName].rawValue, form))
    .filter((x) => x !== null);
};

const computeConstraints = (fieldName, form) => {
  const constraints = form[fieldName].constraints;
  return runFormValidators(fieldName, form, constraints);
};

const computeErrors = (fieldName, form) => {
  const validators = form[fieldName].validators;
  return runFormValidators(fieldName, form, validators);
};

const computeErrorEntries = (formState) => {
  const fields = Object.entries(formState);
  for (let entry of fields) {
    let fieldName = entry[0];
    let errors = computeErrors(fieldName, formState);
    formState[fieldName].errors = errors;
    formState[fieldName].hasErrors = errors.length > 0;
  }
};

const computeDirtyEntries = (formState, changedFieldName) => {
  const fields = Object.entries(formState);
  for (let entry of fields) {
    let fieldName = entry[0];
    let field = entry[1];
    let dirty = fieldName === changedFieldName ? true : field.dirty;
    formState[fieldName].dirty = dirty;
  }
};

function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if("production"!==process.env.NODE_ENV){var i=Y[n],o=i?"function"==typeof i?i.apply(null,t):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return "'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return !!n&&!!n[Q]}function t(n){var r;return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var r=Object.getPrototypeOf(n);if(null===r)return !0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n);})):n.forEach((function(t,e){return r(e,t,n)}));}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?n.add(t):n[r]=t;}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)||(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0)),n}function h(){n(2);}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function _(){return "production"===process.env.NODE_ENV||U||n(0),U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r);}function g(n){O(n),n.p.forEach(S),n.p=null;}function O(n){n===U&&(U=n.l);}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0;}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o,u=o,a=!1;3===e.i&&(u=new Set(o),o.clear(),a=!0),i(u,(function(r,i){return A(n,e,o,r,i,t,a)})),x(n,o,!1),t&&n.u&&b("Patches").N(e,t,n.u,n.s);}return e.o}function A(e,i,o,a,c,s,v){if("production"!==process.env.NODE_ENV&&c===o&&n(5),r(c)){var p=M(e,c,s&&i&&3!==i.i&&!u(i.R,a)?s.concat(a):void 0);if(f(o,a,p),!r(p))return;e.m=!1;}else v&&o.add(c);if(t(c)&&!y(c)){if(!e.h.D&&e._<1)return;M(e,c),i&&i.A.l||x(e,c);}}function x(n,r,t){void 0===t&&(t=!1),!n.l&&n.h.D&&n.m&&d(r,t);}function z(n,r){var t=n[Q];return (t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t);}}function k(n){n.P||(n.P=!0,n.l&&k(n.l));}function E(n){n.o||(n.o=l(n.t));}function N(n,r,t){var e=s(r)?b("MapSet").F(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,R:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return (t?t.A:_()).p.push(e),e}function R(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=D(r,c),u.I=!1;}else e=D(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t));})),3===c?new Set(e):e}(e)}function D(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return "Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return "Unsupported patch operation: "+n},18:function(n){return "The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return "'current' expects a draft, got: "+n},23:function(n){return "'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t);})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=N(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.R[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return !0;E(n),k(n);}return n.o[r]===t&&(void 0!==t||r in n.o)||Number.isNaN(t)&&Number.isNaN(n.o[r])||(n.o[r]=t,n.R[r]=!0),!0},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.R[r]=!1,E(n),k(n)):delete n.R[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12);}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)};})),on.deleteProperty=function(r,t){return "production"!==process.env.NODE_ENV&&isNaN(parseInt(t))&&n(13),on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return "production"!==process.env.NODE_ENV&&"length"!==t&&isNaN(parseInt(t))&&n(14),en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.D=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return (t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=N(e,r,void 0),v=!0;try{f=i(s),v=!1;}finally{v?g(c):O(c);}return "undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.D&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l);}return f}n(21,r);},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r;}));return "undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return [n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze);}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=R(e));var i=w(this),o=N(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q];"production"!==process.env.NODE_ENV&&(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.D=n;},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r;},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce;an.produceWithPatches.bind(an);an.setAutoFreeze.bind(an);an.setUseProxies.bind(an);an.applyPatches.bind(an);an.createDraft.bind(an);an.finishDraft.bind(an);var produce = fn;

const createInitialState = (formConfig) => {
  let initialForm = {};
  const formConfigKeys = Object.keys(formConfig);
  for (let formKey of formConfigKeys) {
    initialForm[formKey] = {
      dirty: false,
      rawValue: formConfig[formKey].defaultValue || '',
      validators: formConfig[formKey].validators || [],
      constraints: formConfig[formKey].constraints || [],
    };
  }
  // Because validators require the entire form we have to do a
  // second pass to add errors once the initial form has been
  // constructed
  for (let formKey of formConfigKeys) {
    let errors = computeErrors(formKey, initialForm);
    initialForm[formKey].errors = errors;
    initialForm[formKey].hasErrors = errors.length > 0;
  }

  return initialForm;
};

const SET = 'field/SET';
const set = (fieldName) => (value) => ({
  type: SET,
  payload: { fieldName, value },
});

const CLEAR = 'form/CLEAR';
const clear = () => ({ type: CLEAR });

const ADD_VALIDATOR = 'field/ADD_VALIDATOR';
const addValidator = (fieldName) => (validator) => ({
  type: ADD_VALIDATOR,
  payload: { fieldName, validator },
});

const REMOVE_VALIDATOR = 'field/REMOVE_VALIDATOR';
const removeValidator = (fieldName) => (validator) => ({
  type: REMOVE_VALIDATOR,
  payload: { fieldName, validator },
});

const CLEAR_FIELD_VALIDATORS = 'field/CLEAR_FIELD_VALIDATORS';
const clearFieldValidators = (fieldName) => () => ({
  type: CLEAR_FIELD_VALIDATORS,
  payload: { fieldName },
});

const createFormReducer =
  (formConfig) =>
  (state = createInitialState(formConfig), action) => {
    switch (action.type) {
      case SET: {
        const changedFieldName = action.payload.fieldName;
        const newRawValue = action.payload.value;

        return produce(state, (draftState) => {
          let originalValue = draftState[changedFieldName].rawValue;
          draftState[changedFieldName].rawValue = newRawValue;
          if (computeConstraints(changedFieldName, draftState).length > 0) {
            // If the change violates constraints, revert the change
            draftState[changedFieldName].rawValue = originalValue;
            return draftState;
          }

          computeDirtyEntries(draftState, changedFieldName);
          computeErrorEntries(draftState);
        });
      }
      case CLEAR:
        return createInitialState(formConfig);
      case ADD_VALIDATOR: {
        const fieldWithOverride = action.payload.fieldName;
        const newValidator = action.payload.validator;

        return produce(state, (draftState) => {
          draftState[fieldWithOverride].validators.push(newValidator);
          computeErrorEntries(draftState);
        });
      }
      case REMOVE_VALIDATOR: {
        const fieldToOverride = action.payload.fieldName;
        const targetValidator = action.payload.validator;

        return produce(state, (draftState) => {
          let fieldValidators = draftState[fieldToOverride].validators;
          draftState[fieldToOverride].validators = fieldValidators.filter(
            (validator) => validator.type !== targetValidator.type
          );
          computeErrorEntries(draftState);
        });
      }
      case CLEAR_FIELD_VALIDATORS: {
        const fieldToClear = action.payload.fieldName;

        return produce(state, (draftState) => {
          draftState[fieldToClear].validators = [];
          computeErrorEntries(draftState);
        });
      }
      default:
        return state;
    }
  };

const createMapDispatchToProps = (formConfig) => {
  // Do memo-ization
  let cachedDispatch;
  let cacheValue;
  return (dispatch) => {
    if (dispatch == cachedDispatch) {
      return cacheValue;
    }
    let dispatchObj = {};
    dispatchObj.fields = {};
    const keys = Object.keys(formConfig);
    for (let fieldName of keys) {
      dispatchObj.fields[fieldName] = {
        set: (value) => dispatch(set(fieldName)(value)),
        addValidator: (validator) => dispatch(addValidator(fieldName)(validator)),
        removeValidator: (validator) =>
          dispatch(removeValidator(fieldName)(validator)),
        clear: () => dispatch(clearFieldValidators(fieldName)()),
      };
    }
    dispatchObj.form = { clear: () => dispatch(clear()) };
    cachedDispatch = dispatch;
    cacheValue = { actions: dispatchObj };
    return cacheValue;
  };
};

const mapStateToProps = (state) => ({ fields: state });

const createFormState = (formConfig) => ({
  reducer: createFormReducer(formConfig),
  mapDispatchToProps: createMapDispatchToProps(formConfig),
  mapStateToProps: mapStateToProps,
});

export { createFormState, dateAfterToday, dateBeforeToday, hasLength, hasLowercaseLetter, hasNumber, hasSpecialCharacter, hasUppercaseLetter, includedIn, includesPotentialCardNumber, isProbablyEmail, isRoutingNumber, isValidMonth, matchesField, matchesRegex, numberGreaterThan, numberGreaterThanOrEqualTo, numberLessThan, numberLessThanOrEqualTo, onlyExpirationDate, onlyIntegers, onlyNaturals, required, validName, validateSum, validateWhen };
